import React, { memo, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, ShoppingBag } from "lucide-react";
import { useCart } from "../../CartContext";
import { userStore } from "../../store/userStore";
import NavLink from "./NavLink";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("");

  const { cartCount, clearCart } = useCart();
  const clearToken = userStore((state) => state.setClearToken);
  const navToken = userStore((state) => state?.token);
  const navigate = useNavigate();

  const handleLinkClick = (linkName) => {
    if (linkName === "Logout") {
      handleLogout();
    }

    setActiveLink(linkName);
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Collections", path: "/shop" },
    { name: "About", path: "/about" },
    { name: "Heritage", path: "/heritage", color: "#C19A5B" },
    { name: "Custom Creations", path: "#" },
    { name: "Lookbook", path: "#" },
    { name: "Contact", path: "/contact" },
  ];

  const handleLogout = () => {
    clearToken();
    clearCart();
    localStorage.removeItem("token");
    navigate("/login");
  };



  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken && storedToken !== "null") {
      userStore.getState().setUserToken(storedToken); // important!
    }
  }, []);
  return (
    <div className="">
      {/* Top bar */}
      {/* Main navigation */}
      <div className="bg-white border-b border-gray-100 px-6 sm:px-12 py-6 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex-shrink-0">
          <h1 className="text-2xl sm:text-3xl font-serif tracking-[0.3em] text-gray-900 uppercase">
            H I R A P A N N A
          </h1>
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden xl:flex items-center space-x-10">
          {navLinks.map((link, index) => (
            <Link
              key={index}
              to={link.path}
              className={`text-[15px] tracking-wide transition-colors duration-200 ${
                link.color ? `text-[${link.color}] font-medium` : "text-gray-600 hover:text-black"
              }`}
              style={link.color ? { color: link.color } : {}}
            >
              {link.name}
            </Link>
          ))}
        </div>

        {/* Icons */}
        <div className="flex items-center space-x-6 sm:space-x-8">
          <button className="text-gray-700 hover:text-black transition-colors">
            <Search size={24} strokeWidth={1.5} />
          </button>
          
          <Link to="/cart" className="relative text-gray-700 hover:text-black transition-colors">
            <ShoppingBag size={24} strokeWidth={1.5} />
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-black text-white text-[10px] rounded-full w-4 h-4 flex items-center justify-center font-bold">
                {cartCount}
              </span>
            )}
          </Link>

          {/* Mobile Menu Button - Moved inside icons area but only visible on small screens */}
          <button
            className="xl:hidden text-gray-700 text-2xl"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile & Tablet Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-[#E9F1ED] p-6 space-y-4">
          {navLinks.map((link, index) => (
            <Link
              key={index}
              to={link.path}
              className="block text-gray-700 text-lg hover:text-yellow-500"
              onClick={() => handleLinkClick(link.name)}
            >
              {link.name}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(Navbar);
